import { Injectable } from '@angular/core';

import {
  CueHistory,
  CueHistoryActivityReview,
  CueHistoryReviewFilter,
  CueUserWarning,
} from 'src/app/models/fincas/cue.model';
import { CueHistoryPresenter } from '../presenters/cue-history.presenter';

/** Provides audit/history presentation helpers for the CUE modal. */
@Injectable({ providedIn: 'root' })
export class CueExportAuditFacade {
  public acceptedActivityLabels(item: CueHistory): string[] {
    return CueHistoryPresenter.acceptedActivityLabels(item);
  }

  public acceptedCount(item: CueHistory): number {
    return CueHistoryPresenter.acceptedCount(item);
  }

  public actionableIssues(item: CueHistory): CueUserWarning[] {
    return CueHistoryPresenter.actionableIssues(item);
  }

  public activityReviews(item: CueHistory, filter: CueHistoryReviewFilter): CueHistoryActivityReview[] {
    return CueHistoryPresenter.activityReviews(item, filter);
  }

  public historyErrors(item: CueHistory): string {
    return CueHistoryPresenter.historyErrors(item);
  }

  public historySummary(item: CueHistory): string {
    return CueHistoryPresenter.historySummary(item);
  }

  public pendingCount(item: CueHistory): number {
    return CueHistoryPresenter.pendingCount(item);
  }

  public rejectedCount(item: CueHistory): number {
    return CueHistoryPresenter.rejectedCount(item);
  }

  public technicalDetails(item: CueHistory): string {
    return CueHistoryPresenter.technicalDetails(item);
  }
}
